import React from 'react';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import classNames from 'classnames';
import './index.scss';

import Dropdown from '../Dropdown';
import AddressAutocomplete from '../AddressAutocomplete';
import IconButton from '../IconButton';

import {FIND_ADDRESS_TYPE_ACTION} from '../../../utils/enums';
import {getRestaurantCityList} from '../../../services/order';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon';
import {columnIsRequired} from '../../../services/filter';

const SectionItemAddress = ({ t, restaurant, column, value, onPropChange, item }) => {
  const cities = getRestaurantCityList(restaurant);
  const handleOnSearch = () => {

    return new Promise(resolve => {
      resolve();

      if(!column.isReadonly){
        onPropChange({
          searchInfo: {
            searchAddress: value.address.street,
            typeAction: FIND_ADDRESS_TYPE_ACTION.findByAddress
          }
        });
      }
    });

  };
  const handleOnCityChange = city => {
    if(column.isReadonly){
      return;
    }

    onPropChange({
      [column.accessor]: { ...value, address: { ...value.address, city }}
    });
  }

  const handleOnNotesChange = ({target}) => {
    if(column.isReadonly){
      return;
    }

    onPropChange({
      [column.accessor]: { ...value, address: { ...value.address, notes: target.value }}
    });
  }
  // const findCurrentCity = cities.find((e) => e.city === value.address.city);

  return (
      <div className={"wrapSectionItemAddress"}>
        <div key={`propItem-${column.accessor}`} className={classNames("sectionItemAddress")}>
          <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
          <div className={classNames("propItemControl")}>
            {value && (
                <Dropdown
                    readonly={column.isReadonly}
                    values={cities}
                    labelField="city"
                    valueField="city"
                    searchBy="city"
                    isCanBeEmpty={column?.isCanBeEmpty}
                    placeholder={""}
                    value={(value.address && value.address.city) || (column.withEmpty ? "" : (cities[0] && cities[0].city))}
                    onSelect={val=> handleOnCityChange(val.city)}
                    onChange={handleOnCityChange}
                />
            )}
            {value && (
                <AddressAutocomplete
                    readonly={column.isReadonly}
                    debounce={500}
                    value={(value.address && value.address.street) || ""}
                    countryCode={restaurant.countryCode}
                    city={(value.address && value.address.city) || (cities[0] && cities[0].city)}
                    handleOnChange={val =>
                        onPropChange({
                          [column.accessor]: {
                            ...value,
                            address: {
                              ...value.address,
                              street: val
                            }
                          }
                        })
                    }
                    handleSelect={val => onPropChange({ [column.accessor]: val })}
                />
            )}
            {column.isShowIcon && value && (
                <IconButton
                    isIcon={true}
                    iconName={"search"}
                    tooltipText={t("new-order-directive.FIND_BY_ADDRESS_TOOLTIP")}
                    onClick={handleOnSearch}
                />
            )}
          </div>
        </div>
        {column.withNotes && value && (
            <div key={`sectionItemText-${column.accessor}`} className={classNames("sectionItemText")}>
              <div className={classNames("propItemLabel")}>{t("new-order-directive.ADDRESS_NOTES")}</div>
              <form autoComplete="off" className={classNames("inputItem", { required: columnIsRequired(column, item) })}>
                <input type="text"
                       placeholder={column.placeholder || ""}
                       autoComplete="new-password"
                       value={(value.address && value.address.notes) || ""}
                       readOnly={column.isReadonly}
                       minLength={column.minlength}
                       maxLength={column.maxLength}
                       onChange={handleOnNotesChange}
                />
              </form>
            </div>
        )}
      </div>
  );
};

const mapStateToProps = state => ({
  restaurant: state.restaurant.data
});

export default connect(mapStateToProps)(withTranslation()(SectionItemAddress));
